import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=7d72ef74&scoped=true&"
import script from "./roleManagement.vue?vue&type=script&lang=js&"
export * from "./roleManagement.vue?vue&type=script&lang=js&"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=7d72ef74&lang=scss&scoped=true&"
import style1 from "./roleManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d72ef74",
  null
  
)

component.options.__file = "roleManagement.vue"
export default component.exports